/* storybook-check-ignore */
import { css } from '@emotion/react';
import { BoxProps, Flex, Text } from '@opendoor/bricks/core';
import { media } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';
import AccountConnector, { AccountProps } from 'components/shared/AccountConnector';
import { ListingWithComputedProperties } from 'declarations/exclusives/listing';
import { FavoriteButtonWithoutWatchlistContextProvider } from './FavoriteButton';
import SharingLinksButton from './SharingLinksButton';

interface Props extends BoxProps, AccountProps {
  listing: ListingWithComputedProperties;
  onSharingSuccess?: (message: string) => void;
  onSharingError?: (message: string) => void;
}

function HeroActions({
  listing,
  loggedIn,
  infoIsLoading,
  email,
  human,
  onSharingError,
  onSharingSuccess,
  ...props
}: Props) {
  const accountEmail = !infoIsLoading && loggedIn ? email || human.get('email') : undefined;
  return (
    <Flex
      flexDirection="row"
      flex={1}
      justifyContent="flex-end"
      display="flex"
      position={['absolute', null, null, 'relative']}
      top={['106px', null, null, 'unset']}
      right={['1rem', null, null, 'unset']}
      gridGap="0.75rem"
      {...props}
    >
      <SharingLinksButton
        listing={listing}
        onSharingError={onSharingError}
        onSharingSuccess={onSharingSuccess}
        source="pdp"
        style={{ border: '1px solid rgba(207, 215, 251, 0.41)' }}
      />
      <FavoriteButtonWithoutWatchlistContextProvider
        listing={listing}
        accountEmail={accountEmail}
        width="auto"
        gridGap="0.2rem"
        paddingX="0.75rem"
        minWidth="90px"
        css={css`
          ${media.largerThan.MD} and (max-width: 1312px) {
            min-width: unset;
            padding: 0;
            width: 36px;
            span {
              display: none;
            }
          }
        `}
        style={{ border: '1px solid rgba(207, 215, 251, 0.41)' }}
        {...(infoIsLoading && { disabled: true })}
      >
        {({ isOnWatchlist }) => (
          <Text
            as="span"
            fontSize="s1"
            fontWeight="semibold"
            {...(isOnWatchlist ? { color: 'brand50' } : null)}
          >
            {isOnWatchlist ? 'Saved' : 'Save'}
          </Text>
        )}
      </FavoriteButtonWithoutWatchlistContextProvider>
    </Flex>
  );
}

export default AccountConnector(HeroActions);
